<template>
  <div>
    <v-card elevation="5">
      <v-toolbar color="primaryLight" dark dense>
        <v-toolbar-title>Datos incendio</v-toolbar-title>

        <v-progress-circular class="ml-4" v-show="updatingEstadoIncendio || updatingNivelIncendio" indeterminate />

        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn fab small v-bind="attrs" v-on="on" color="secondary" bottom right absolute @click="showDialogEditIncendio = true" :disabled="disabledByRol">
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar incendio</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn fab small v-bind="attrs" v-on="on" color="secondary" v-show="showAddNiveles" :disabled="disableAddNivel || disabledByRol" bottom right absolute @click="changeVisibilityNivelIncendio" :style="{marginRight: '50px'}">
              <v-icon color="primary">mdi-car-brake-fluid-level</v-icon>
            </v-btn>
          </template>
          <span v-if="disableAddNivel">Es necesario finalizar el anterior nivel</span>
          <span v-else>Añadir nivel incendio</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text>
        <div>
          <p v-if="emergencia.NOMBRE" class="subtitle-1 black--text">Nombre: {{ emergencia.NOMBRE }}</p>
          <p class="subtitle-1 black--text">Municipio: {{ emergencia.MUNICIPIO }}</p>
          <p class="subtitle-1 black--text">Localidad: {{ emergencia.LOCALIDAD }}</p>
          <p class="subtitle-1 black--text">Coordenadas: {{ emergencia.LATITUD }}, {{ emergencia.LONGITUD }}</p>
          <p class="subtitle-1 black--text">Detección: {{ deteccion.DETECCION }}</p>
          <p class="subtitle-1 black--text">Observaciones: {{ emergencia.OBSERVACIONES }}</p>
        </div>

        <v-data-table :headers="headers" :items="emergencia.ESTADOS" hide-default-footer>
          <template #[`header.ACCIONES`]="{ }">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="showIncendioEstadoEdit()">
                  <v-icon color="black">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar estado incendio</span>
            </v-tooltip>
          </template>
          <template #no-data>
            <p>Datos no disponibles.</p>
          </template>

          <template #[`item.FECHA`]="{ item }">
            <span>{{ item.FECHA | formatDate }}</span>
          </template>

          <template #[`item.ESTADO`]="{ item }">
            <v-chip class="chip" :color="item.EMERGENCIA_ESTADO_TIPO.COLOR" dark>
              {{ item.EMERGENCIA_ESTADO_TIPO.EMERGENCIA_ESTADO }}
            </v-chip>
          </template>

          <template #[`item.ACCIONES`]="{ item }">
            <!--<v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="showIncendioEstadoEdit(item.TIPO_INCENDIO_ESTADO.VALUE)">
                  <v-icon color="black">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar estado incendio</span>
            </v-tooltip>-->

            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <div class="d-inline-block" v-bind="attrs" v-on="on">
                  <v-btn icon :disabled="disableFinalizar" v-if="showAddEstado(item)" @click="setEstadoIncendio(item.EMERGENCIA_ESTADO_TIPO)">
                    <v-icon color="black">mdi-plus</v-icon>
                  </v-btn>
                </div>
              </template>
              <span v-if="disableFinalizar">Es necesario finalizar las actuaciones de los medios <br>y finalizar el ultimo nivel del incendio</span>
              <span v-else>Añadir estado incendio</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" v-show="showRemoveEstado(item)" @click="deleteEstadoIncendio()">
                  <v-icon color="black">mdi-minus</v-icon>
                </v-btn>
              </template>
              <span>Quitar estado incendio</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <v-data-table :headers="headers2" :items="incendio.NIVELES" hide-default-footer v-if="showNivelesTable">
          <template #[`item.NIVEL`]="{ item }">
            <v-chip class="chip" :color="item.TIPO_INCENDIO_NIVEL.COLOR" dark>
              {{ item.TIPO_INCENDIO_NIVEL.INCENDIO_NIVEL }}
            </v-chip>
          </template>
          <template #[`item.FECHA_INICIO`]="{ item }">
            <span>{{ $date.formatDate(item.FECHA_INICIO,dateFormat) }}</span>
          </template>
          <template #[`item.FECHA_FIN`]="{ item }">
            <span>{{ $date.formatDate(item.FECHA_FIN,dateFormat) }}</span>
          </template>

          <template #[`item.ACCIONES`]="{ item, index}">
            <!--<template #[`item.ACCIONES`]="{ item,index}">-->
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="showEditNivelDialog(item,index)">
                  <v-icon color="black">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar nivel incendio</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <div class="d-inline-block" v-bind="attrs" v-on="on">
                  <!-- Hack para mostrar tooltip con boton disabled -->
                  <v-btn icon v-show="showRemoveNivel(item)" @click="deleteNivelIncendio()" :disabled="disabledByRol">
                    <v-icon color="black">mdi-minus</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>Eliminar el nivel</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <vx-dialog-edit-incendio :show="showDialogEditIncendio" :emergencia="emergencia" @aceptar="aceptarEditIncendio" @cancelar="showDialogEditIncendio = false" />
    <vx-dialog-add-nivel-incendio :show="showAddNivelIncendioDialog" @aceptar="changeVisibilityNivelIncendio" @cancelar="changeVisibilityNivelIncendio" :idIncendio="incendio.ID_INCENDIO" :emergencia="emergencia" @redrawIncendio="redrawIncendio" />
    <vx-dialog-edit-nivel-incendio :show="showEditNivelIncendioDialog" @close="showEditNivelIncendioDialog = false" :idIncendio="incendio.ID_INCENDIO" :emergencia="emergencia" :dataNivel="dataNivel" @redrawIncendio="redrawIncendio" />
    <vx-dialog-edit-incendio-estado :show="showDialogEstadoEdit" :emergencia="emergencia" @close="showDialogEstadoEdit = false" />
  </div>
</template>

<script>
/* eslint-disable */

import DialogAddNivelIncendio from './DialogAddNivelIncendio.vue'
import DialogEditNivelIncendio from './DialogEditNivelIncendio.vue'
import DialogEditIncendio from './DialogEditIncendio.vue'
import DialogEditIncendioEstado from './DialogEditIncendioEstado.vue'

import * as ArcGIS from '@/helpers/ArcGIS.js'
import DateService, { FMT } from '@/helpers/DateService'

import { moment } from 'vis-timeline/standalone'

export default {
  components: {
    'vx-dialog-edit-incendio-estado': DialogEditIncendioEstado,
    'vx-dialog-edit-incendio': DialogEditIncendio,
    'vx-dialog-add-nivel-incendio': DialogAddNivelIncendio,
    'vx-dialog-edit-nivel-incendio': DialogEditNivelIncendio

  },

  props: {
    idEmergencia: String
  },

  data: () => ({
    headers: [
      { text: 'FECHA', value: 'FECHA', align: 'left', sortable: true },
      { text: 'ESTADO', value: 'ESTADO', align: 'center', sortable: false },
      { text: 'ACCIONES', value: 'ACCIONES', align: 'center', width: '25%', sortable: false }
    ],
    headers2: [
      { text: 'FECHA INICIO', value: 'FECHA_INICIO', align: 'left', sortable: true },
      { text: 'FECHA FIN', value: 'FECHA_FIN', align: 'left', sortable: true },
      { text: 'NIVEL', value: 'NIVEL', align: 'center', sortable: false },
      { text: '', value: 'ACCIONES', align: 'center', width: '25%', sortable: false }
    ],

    updatingEstadoIncendio: false,
    updatingNivelIncendio: false,

    showAddNivelIncendioDialog: false,
    showEditNivelIncendioDialog: false,
    dataNivel:null,

    showDialogEditIncendio: false,

    showDialogEstadoEdit: false,
    showDialogEstadoAdd: false,

    codigoTipoEstadoEdit: null,
    dateFormat: FMT.date,

  }),

  computed: {
    emergencia () {
      let emergencia = JSON.parse(JSON.stringify(this.$store.getters['emergencia/getEmergenciaByID'](this.idEmergencia)))
      return emergencia || {}
    },
    incendio () {
      let incendio = this.emergencia.INCENDIO ? this.$store.getters['incendio/getIncendioByID'](this.emergencia.INCENDIO.ID_INCENDIO) : null
      return incendio ? JSON.parse(JSON.stringify(incendio)) : {}
    },
    deteccion () {
      let deteccion = this.incendio ? this.$store.getters['incendio/getTipoDeteccionById'](this.incendio.ID_TIPO_DETECCION) : null
      return deteccion || {}
    },
    disableFinalizar () {
      return (!this.actuacionesCerradas && this.emergencia.ESTADOS[0].EMERGENCIA_ESTADO_TIPO.VALUE === 3) || (this.showNivelesTable && this.emergencia.ESTADOS[0].EMERGENCIA_ESTADO_TIPO.VALUE === 3 && this.disableAddNivel )
    },
    showNivelesTable() {
      return this.incendio.NIVELES && this.incendio.NIVELES.length > 0
    },
    showAddNiveles() {
      if(this.emergencia.ESTADOS){
        return this.emergencia.ESTADOS[0].EMERGENCIA_ESTADO_TIPO.VALUE !== 4
      }
      return false
    },

    disableAddNivel(){
      return this.incendio.NIVELES && this.incendio.NIVELES.length > 0 && this.incendio.NIVELES[0].FECHA_FIN ==null
    },

    actuacionesCerradas () {
      for (let i = 0; i < this.emergencia.SECTORES.length; i++) {
        let sector = this.emergencia.SECTORES[i]

        for (let j = 0; j < sector.MEDIOS.length; j++) {
          let medio = sector.MEDIOS[j]

          if (!medio.FECHA_LLEGADA_BASE) {
            return false
          }
        }
      }
      return true
    },
    disabledByRol () {
      // Deshabilita funciones dependiendo del rol
      return !this.$store.getters['usuario/isCurrentUsuarioAdmin']
    }
  },

  watch: {
    emergencia: {
      handler (val, oldVal) {
        if ((val && val.ID_EMERGENCIA) && (oldVal && oldVal.ID_EMERGENCIA)) {
          const didLatLonChange = val.LATITUD !== oldVal.LATITUD || val.LONGITUD !== oldVal.LONGITUD
          const didEstadosChange = val.ESTADOS.length !== oldVal.ESTADOS.length
          if (didLatLonChange || didEstadosChange) {
            this.redrawIncendio()
          }
        }
      },
      deep: true
    }
  },

  methods: {
    showEditNivelDialog(item,index){
      this.dataNivel = item
      this.dataNivel = {...this.dataNivel, index :index}
      this.showEditNivelIncendioDialog = true
    },
    showRemoveNivel(item){
      return item.ID_INCENDIO_NIVEL === this.incendio.NIVELES[0].ID_INCENDIO_NIVEL
    },
    changeVisibilityNivelIncendio () {
      this.updatingEstadoIncendio = !this.updatingEstadoIncendio
      this.showAddNivelIncendioDialog = !this.showAddNivelIncendioDialog
    },
    showAddEstado (item) {
      let isEstadoMasReciente = item.EMERGENCIA_ESTADO_TIPO.VALUE === this.emergencia.ESTADOS[0].EMERGENCIA_ESTADO_TIPO.VALUE
      let noIsFinalizado = this.emergencia.ESTADOS[0].EMERGENCIA_ESTADO_TIPO.VALUE < 4

      // Comprobacion dos estados en el mismo minuto
      let date = new Date(this.emergencia.ESTADOS[0].FECHA)
      let dateNow = new Date()

      let isSameMinute = (dateNow.getTime() - date.getTime()) > 60000 // 60000 ms = 1 min
      return isEstadoMasReciente && noIsFinalizado && isSameMinute
    },

    showRemoveEstado (item) {
      let isEstadoMasReciente = item.EMERGENCIA_ESTADO_TIPO.VALUE === this.emergencia.ESTADOS[0].EMERGENCIA_ESTADO_TIPO.VALUE
      let noIsInicio = this.emergencia.ESTADOS[0].EMERGENCIA_ESTADO_TIPO.VALUE !== 0

      return isEstadoMasReciente && noIsInicio
    },

    aceptarEditIncendio (emergencia) {
      this.$store.dispatch('emergencia/updateEmergencia', emergencia)
      this.showDialogEditIncendio = false
    },

    setEstadoIncendio (estado) {
      if (this.updatingEstadoIncendio) return

      this.updatingEstadoIncendio = true
      let estadosIncendio = this.$store.getters['emergencia/emergenciaEstadoTipo'].toSorted((x, y) => {
        return x.VALUE - y.VALUE
      })

      let estadoAdd
      for (let i = 0; i < estadosIncendio.length; i++) {
        if (estado.VALUE === estadosIncendio[i].VALUE) {
          estadoAdd = estadosIncendio[i + 1]
          break
        }
      }

      let estadoIncendio = {
        ID_EMERGENCIA_ESTADO: this.$uuid.createUUID(),
        ID_EMERGENCIA_ESTADO_TIPO: estadoAdd.ID_EMERGENCIA_ESTADO_TIPO,
        ID_EMERGENCIA: this.idEmergencia,
        FECHA: this.$date.now()
      }

      this.$store.dispatch('emergencia/addEstadoEmergencia', estadoIncendio).then(() => {
      }).catch((e) => {
        this.$notify({
                  title: `Cambio de estado`,
                  text: `Error al cambiar el estado del incendio a ${estadoAdd.EMERGENCIA_ESTADO}`,
                  type: 'error'
                })
      }).finally(() => {
        this.updatingEstadoIncendio = false
      })

    },

    deleteEstadoIncendio () {
      if (this.updatingEstadoIncendio) return

      this.updatingEstadoIncendio = true

      let data = {
        ID_EMERGENCIA_ESTADO: this.emergencia.ESTADOS[0].ID_EMERGENCIA_ESTADO,
        ID_EMERGENCIA: this.emergencia.ESTADOS[0].ID_EMERGENCIA,
        NUEVO_ESTADO: this.emergencia.ESTADOS[1].EMERGENCIA_ESTADO_TIPO.EMERGENCIA_ESTADO
      }

      this.$store.dispatch('emergencia/deleteEstadoIncendio', data)
      setTimeout(() => {
        this.updatingEstadoIncendio = false
      }, 1000)
    },
    deleteNivelIncendio () {
      if (this.updatingNivelIncendio) return

      this.updatingNivelIncendio = true

      let data = {
        ID_INCENDIO_NIVEL: this.incendio.NIVELES[0].ID_INCENDIO_NIVEL,
        ID_INCENDIO: this.incendio.NIVELES[0].ID_INCENDIO,
      }

      this.$store.dispatch('incendio/deleteNivelIncendio', data)
      setTimeout(() => {
        this.redrawIncendio()
        this.updatingNivelIncendio = false
      }, 1000)
    },

    showIncendioEstadoEdit () {
      this.showDialogEstadoEdit = true
    },

    redrawIncendio () {
      ArcGIS.redrawIncendios()
    }
  }
}
</script>

<style scoped>
  .chip {
    width: 150px;
  }

  .chip >>> .v-chip__content { /* Centrar texto chips */
    margin: auto !important;
  }
</style>
